export enum ProfileQuickAccessTabs {
  about = "About",
  resume = "Resume",
  educationWithSuraasa = "Education with Suraasa",
  skillPortfolio = "Skill Portfolio",
  topSkillEvidences = "Skill Evidences",
  otherDetails = "Other Details",
}
